import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { UserEditorPage, UsersPage } from './pages'

const UsersRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.OTHER.subMenuItems.USERS.link}
      permissions={PERMISSIONS.USER.LIST}
      component={UsersPage}
    />
    <PermissionRoute
      permissions={PERMISSIONS.USER.CREATE}
      exact
      path={APP_ROUTES.USER_CREATE.link}
      component={UserEditorPage}
    />
    <PermissionRoute
      permissions={[PERMISSIONS.USER.UPDATE, PERMISSIONS.USER.GET]}
      exact
      path={APP_ROUTES.USER_DETAILS.link}
      component={UserEditorPage}
    />
  </Switch>
)

export default UsersRouter
